export interface Badge {
  id: number;
  operatoreId: number;
  codiceBadge: string;
  descrizione?: string;
  isActive: boolean;
  created: string; // ISO 8601
  lastUsed?: string;
  revoked?: string;
  livelloSicurezza?: number; // 1 = Standard, 2 = Alta; assente = badge da tessera fisica
  isTemporary?: boolean;
  expiresAtUtc?: string;
}

export interface RegisterBadgeRequest {
  operatoreId: number;
  codiceBadge: string;
  descrizione?: string;
}

export interface GenerateBadgeRequest {
  operatoreId: number;
  descrizione?: string;
  livelloSicurezza: number; // 1 | 2
}

export interface TemporaryBadgeVerificationRequest {
  userName: string;
  dataNascita: string;
  luogoNascita: string;
}

export interface TemporaryBadgeIssueRequest extends TemporaryBadgeVerificationRequest {
  badgeFisicoId?: number;
}

export interface TemporaryBadgeCandidate {
  id: number;
  descrizione?: string;
  created: string;
}

export interface TemporaryBadgeCandidates {
  userName: string;
  badges: TemporaryBadgeCandidate[];
}

export const BadgeLivelloSicurezza = {
  Standard: 1,
  Alta: 2
} as const;
